import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConfiguracionEmpresa;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    error?: kea.FieldError;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        SerieFacturas: validation.required,
        ClaveSatMoneda: validation.required,
        ClaveSatRegimenFiscalEmisor: validation.required,
        ClaveSatUsoReceptor: validation.required,
        NombreEmisor: validation.required,
        SerieNotaCredito: validation.required,
        SerieNotaCargo: validation.required,
        LimiteSeguroInterno: validation.required,
        //TODO: No esta f uncionando esto
        TipoCambioNotaCredito: validation.rangeEx(0)
    }
    return validation.getErrors(rules, x);
}

/**
* Componente auxiliar para mostrar la parte del receptor de las facturas
*/
export class ConfiguracionEmpresaNoRX extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = kea.formfields(() => this.props, () => this.errors(this.props));

    render() {
        var { value } = this.props;
        const getField = this.getField;

        const Checkbox = getField(kea.Checkbox);
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Moneda = getField(selectores.ClaveMonedaSat);
        const UsoCFDI = getField(selectores.ClaveUsoCFDISat);
        const Regimen = getField(selectores.ClaveRegimenFiscalSat);

        return (
            <kea.Panel title="Configuración de la empresa" error={this.props.error} >
                {kea.autogrid(6, [
                    <Text field="Calle" label="Calle:" />,
                    <Text field="Telefono" label="Teléfono:" />,
                    <Text field="NombreEmisor" label="Nombre del emisor:" />,
                    <Text field="Rfc" label="RFC de emisor:" />,
                    <Text field="SerieFacturas" label="Serie de facturas:" />,
                    <Moneda field="ClaveSatMonedaManual" label="Clave SAT moneda default para las facturas manuales:" />,
                    <Regimen field="ClaveSatRegimenFiscalManual" label="Clave SAT regimen fiscal default para las facturas manuales:" />,
                    <Text field="SerieNotaCredito" label="Serie de notas de credito:" />,
                    <UsoCFDI field="ClaveSatUsoCFDINotaDeCredito" label="Uso de CFDI default de notas de crédito:" />,
                    <Text field="SerieNotaCargo" label="Serie de notas de cargo:" />,
                    <Text field="CodigoPostal" label="Codigo postal:" />,
                    <Text field="NoCuentaBeneficiaria" label="Número de cuenta beneficiaria:" />,
                    <Regimen field="ClaveSatRegimenFiscalEmisor" label="Clave SAT Regimen Emisor:" />,
                    <UsoCFDI field="ClaveSatUsoReceptor" label="Clave SAT Uso CFDI receptor:" />,
                    <Moneda field="ClaveSatMoneda" label="Clave SAT Moneda:" />,
                    <Number field="TipoCambioNotaCredito" label="Tipo de cambio para notas de crédito" />,
                    <Number field="DiasParaFacturar" label="Días para facturar" />,
                    <Number field="LimiteSeguroInterno" label="Límite para seguro interno" />,
                    <Checkbox field="ModoPruebas" label="¿Timbrar en modo de pruebas?" />
                ])}
            </kea.Panel>
        );
    }
}

export const ConfiguracionEmpresa = componentToRx(ConfiguracionEmpresaNoRX);



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/configuracionempresa.tsx